module.exports = __webpack_public_path__ + "static/media/bike.2af09ee7.png";